import api from "./Api";

class VariacaoItemService {
  GetVariacaoItem(payload) {
    return api.get("/v1/variacaoItem/" + payload).then((response) => {
      return response.data;
    });
  }

  PostVariacaoItem(payload) {
    return api.post("/v1/variacaoItem/", payload).then((response) => {
      return response.data;
    });
  }

  PutVariacaoItem(payload) {
    return api.put("/v1/variacaoItem/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteVariacaoItem(payload) {
    return api.delete("/v1/variacaoItem/" + payload).then((response) => {
      return response.data;
    });
  }

  GetVariacaoItemOData(payload) {
    return api.get("/OData/VariacaoItem" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new VariacaoItemService();
